import { Location, TitleCasePipe } from '@angular/common';
import { AfterViewInit, Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { PurchaseOrderDto, Workflow } from '@models/index';
import { NbThemeService } from '@nebular/theme';
import { NgbPopoverConfig, NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { CompanyService, Toaster } from '@services/index';
import { DxDataGridComponent } from 'devextreme-angular';
import DevExpress from 'devextreme/bundles/dx.all';
import * as moment from 'moment';
import { LocalStorage } from 'ngx-webstorage';
import { environment } from '@env/environment';
import { WorkflowCreationModalComponent } from '@app/modules/workflows/modals/workflow-creation-modal/workflow-creation-modal.component';

@Component({
  selector: 'ngx-workflows',
  templateUrl: './workflows.component.html',
  styleUrls: ['./workflows.component.scss'],
})
export class WorkflowsComponent implements OnInit, OnDestroy, AfterViewInit {
  isRCDSS = environment.name === 'rcdss';
  @LocalStorage() organizationId: string;
  @LocalStorage() role: string;
  @ViewChild('grid') dataGrid: DxDataGridComponent;

  loading: boolean = false;

  workflows: Workflow[];
  purchaseOrderId: string = null;
  selectedIndex: number = -1;

  constructor(
    config: NgbPopoverConfig,
    private $company: CompanyService,
    private activatedRoute: ActivatedRoute,
    private toaster: Toaster,
    public router: Router,
    private $modal: NgbModal,
    protected location: Location,
  ) {
    config.placement = 'left';
    config.triggers = 'hover';
  }

  ngOnInit() {
    this.getData();
  }

  ngAfterViewInit(): void {
  }

  ngOnDestroy() {
  }

  getData() {
    try {
      this.$company.workflows(this.organizationId).subscribe((workflows) => {
        this.workflows = workflows;
      });
    } catch (error) {
      console.error(error);
      const errMsg = error.error && error.error.detail ? error.error.detail : error.message;
      this.toaster.show('error', 'An error occurred', 'Please try again later');
    }
  }

  onContentReadyHandler(event) {
    // event.component.selectRowsByIndexes([this.selectedIndex]);
  }

  selectDataGridRow(event) {
    if (event.event) {
      this.selectedIndex = event.rowIndex;
      if (event.rowType !== 'data') return;
    }

    if (event.data) {
      this.openWorkflow(event.data.id);
    }
  }

  openWorkflow(workflowId) {
    this.router.navigate(['/workflows', workflowId], {});
  }

  openNewWorkflowModal() {
    const modalRef = this.$modal.open(WorkflowCreationModalComponent, {
      size: 'md',
      container: 'nb-layout',
    });
    modalRef.componentInstance.organizationId = this.organizationId;
    modalRef.result.then((result) => {
      this.openWorkflow(result.id);
    }, (error) => {
      console.error(error);
    });
  }

  refreshGrid() {
    this.dataGrid.instance.deselectAll();
  }

  refreshTable() {
    this.dataGrid.instance.collapseAll(-1);
    this.refreshGrid();
  }

}
